import { h, Component, Fragment } from 'preact';
import WidgetComponent from 'components/WidgetComponent'
import {connect} from 'react-redux'
import style from './style'
import dayjs from 'lib/helpers/dayjs';
import { I18n, Button } from 'components/elements'
import {WaitingRoom} from 'components/groups'
import {SessionActions,PageActions} from 'actions';
import { FACheckCircle } from 'components/elements/FontAwesome';


@connect((state)=> state)
export default class Receipt extends WidgetComponent {
	constructor(){
        super()
        this.handleBack = this.handleBack.bind(this)
        this.handleLogout= this.handleLogout.bind(this)
    }
    
    handleLogout(e){
        SessionActions.logout()
    }

    handleBack(e){
        PageActions.reset()
    }

    get account() {
        return (this.props.session || {}).account || {};
    }

    get administrator(){
        return this.props.administrators[this.props.selectedTimeSlot.administratorID] || {}
    }
    
    get patients(){
        return Object.values(this.props.patients || {}).filter((patient)=> Object.keys(this.props.selectedPatients).includes(patient.id))
    }

    get patientNames(){
        let names = []
        this.patients.forEach((patient)=>{
            if(!names.length){
                names.push(`${patient.firstName}`)
            } else {
                names.unshift(patient.firstName)
            }
        })
        // names.unshift('you')
        return names
    }

    get appointment(){
        return this.props.timeSlots[this.props.selectedTimeSlot.administratorID][this.props.selectedTimeSlot.id] || {}
    }

    parseAndSentence(sentence){
        
        if(sentence.length == 1){
            return (
                <Fragment>
                    <I18n>and</I18n> {sentence}
                </Fragment>
            )
        }else{
            return (
                <Fragment>
                    {sentence.slice(0, sentence.length - 1).join(', ')}, <I18n>and</I18n> {sentence.slice(sentence.length - 1, sentence.length)}
                </Fragment>
            )
        }
    }
	render() {
		return (
            <div>
                <div class={style.header}>
                    <FACheckCircle /> <I18n>thankYou</I18n> {this.account.firstName}
                </div>
                {this.props.config.placeholderAppointment ?
                    <div class={style.body}>
                        Your information has successfully been submitted.
                        <br />
                        <br />
                        <br />
                        <I18n>weLookForwardToSeeingYouAnd</I18n>{this.patientNames}!
                    </div>
                :
                    <div class={style.body}>
                        <I18n>yourAppointmentWith</I18n> {this.administrator.title} {this.administrator.firstName} {this.administrator.lastName} <I18n>hasBeenConfirmedFor</I18n> <br /> {dayjs(this.appointment.startsAt).format('dddd, MMM DD')} <I18n>at</I18n> {dayjs(this.appointment.startsAt).format('hh:mm A')}. 
                        <br />
                        <br />
                        <br />
                        {/* check this, the 'you and' is still showing even in spanish */}
                        <I18n>weLookForwardToSeeingYou</I18n>, {this.parseAndSentence(this.patientNames)}!
                    </div>
                }
                {this.props.waitingRoom &&
                    <div style={{paddingBottom: '50px'}}>
                        <WaitingRoom />
                    </div>
                }
                <div class={style.footer}>
                    <strong>Finished booking?</strong>
                    <br />
                    <br />
                    <Button onClick={this.handleLogout} class={style.link}><I18n>logOut</I18n></Button>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <strong>Need another appointment?</strong>
                    <div onClick={this.handleBack} class={style.link}><I18n>backToStart</I18n></div>
                </div>
                
            </div>
		)
	}
}


// WEBPACK FOOTER //
// ./components/templates/Receipt/index.js